import type { MenuProps } from 'antd';
export const DEFAULT_NAME = 'Bcare Portal';
export const X_CSRF_TOKEN = 'X-CSRF-TOKEN';

export const topMenuPartyId = 0;
export const topMenuSeq = 0;
export const FORM_LAYOUT = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const roleNames = {
  1: 'Master PIC',
  2: 'Normal Company PIC',
  3: 'Branch PIC',
  4: 'Sales Agent PIC',
  5: 'Sales Operation PIC',
  6: 'Sales PIC',
};

// 配置后台返回和我们自己要用到国际化key的映射关系
export const languagesMapping: Record<string, string> = {
  en: 'en-US',
  fr: 'fr-BE',
  ar: 'ar-LY',
};

export const OPERATION_A = 'A';
export const OPERATION_B = 'B';
export const OPERATION_M = 'M';
export const OPERATION_D = 'D';

// 下载模版文件格式
export const items: MenuProps['items'] = [
  {
    key: 'EXCEL',
    label: 'EXCEL',
  },
  {
    key: 'CSV',
    label: 'CSV',
  },
  {
    key: 'TXT',
    label: 'TXT',
  },
];

// bcare admin code
export const BCARE_ADMIN_CODE = 'BCARE_ADMIN';

export const SERVICE_NUMBER_PREFIX = '60';
